import React from 'react';
import './Hero.css';
import { Link } from 'react-router-dom'; 
import { FaUsers } from 'react-icons/fa';
const Hero = () => {

const scrollToServices = () => {
    const section = document.getElementById("servicos-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" }); // rolagem suave
    }
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Soluções digitais para o seu negócio</h1>
        <p>Transformamos suas ideias em realidade digital</p>
        <div className="hero-buttons">
          <Link onClick={scrollToServices} className="btn-primary">Nossos Serviços</Link>
          <Link to="/contato" className="btn-secondary">Fale Conosco</Link>
        </div>
        <h2 className="hero-outsourcing-title">
          <FaUsers aria-hidden="true" />
          <span>Outsourcing em IT</span>
        </h2>
      </div>
    </section>
  );
};

export default Hero; 
